import React from 'react'
import PropTypes from 'prop-types'

export const CloseXButton = ({onClick}) => (
  <button
    className   = "close x"
    onClick     = { onClick }
    aria-label  = "Close"
    role        = "button"
    >
    <i className="fas fa-times" />
  </button>
)

CloseXButton.propTypes = {
  onClick: PropTypes.func.isRequired
}

export const CloseLeftArrowButton = ({onClick}) => (
  <button
    className   = "close left-arrow"
    onClick     = { onClick }
    aria-label  = "Close"
    role        = "button"
    >
    <i className="fas fa-arrow-left" />
  </button>
)

CloseLeftArrowButton.propTypes = {
  onClick: PropTypes.func.isRequired
}